import { render, staticRenderFns } from "./ClientPermissions.vue?vue&type=template&id=30b3ec2d"
import script from "./ClientPermissions.vue?vue&type=script&lang=js"
export * from "./ClientPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports